export var TextFormat;
(function (TextFormat) {
    TextFormat["HTML"] = "html";
    TextFormat["PLAIN_TEXT"] = "plain_text";
})(TextFormat || (TextFormat = {}));
